import React, { FC } from 'react';
import { Chips, ChipsWrapper, ChipsInnerWrapper } from './CommonCarousel';

type Props = {
  children: (resetScroll: Function) => React.ReactNode;
};

export const TouchCarousel: FC<Props> = ({ children }) => {
  return (
    <Chips>
      <ChipsWrapper>
        <ChipsInnerWrapper>{children(() => null)}</ChipsInnerWrapper>
      </ChipsWrapper>
    </Chips>
  );
};
